import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import t from "./translations";

type Props = {
  open: boolean;
  sourceName: string;
  targetName: string;
  submitting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ConfirmMergeDialog({
  open,
  sourceName,
  targetName,
  submitting,
  onCancel,
  onConfirm,
}: Props) {
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (open) setTyped("");
  }, [open]);

  const canConfirm = typed === sourceName && !submitting;

  return (
    <Dialog open={open} onClose={() => (submitting ? undefined : onCancel())}>

      <DialogTitle>{t.ConfirmDialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t.ConfirmDialogBody(sourceName, targetName)}
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          label={t.ConfirmTypeToConfirmLabel(sourceName)}
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
          disabled={submitting}
          slotProps={{
            htmlInput: { "data-testid": "objectTypeMerge.confirmInput" },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          {t.ConfirmCancel}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={!canConfirm}
          startIcon={
            submitting ? <CircularProgress size={16} color="inherit" /> : undefined
          }
          data-testid="objectTypeMerge.confirmMerge"
        >
          {t.ConfirmMerge}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
